export const SDK_NAME = "sentry.javascript.react-native";
export const SDK_VERSION = "1.3.7";
